import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=a38b791c&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=a38b791c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b791c",
  null
  
)

export default component.exports